export const demoPath = () => "/demo";
export const demoWizardPath = () => "/demo/wizard";
export const demoBotPath = () => "/demo-bot";
